import { render, staticRenderFns } from "./PageUsageDetail.vue?vue&type=template&id=8213cf16&"
import script from "./PageUsageDetail.vue?vue&type=script&lang=js&"
export * from "./PageUsageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8213cf16')) {
      api.createRecord('8213cf16', component.options)
    } else {
      api.reload('8213cf16', component.options)
    }
    module.hot.accept("./PageUsageDetail.vue?vue&type=template&id=8213cf16&", function () {
      api.rerender('8213cf16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/PageUsageDetail.vue"
export default component.exports